<template>
    <div id="LmQmsButtonBuilderUi" class="row align-items-center">
      <hr class="w-100 mx-2">
      <h5 class="col-12">{{ $t('visual_attributes') }}</h5>
      <LmSelect
        class="col-12 col-md-6"
        v-model="component.componentProps.dateFormat"
        :options="dateFormatOptions"
        :label="$t('date_format')"
        :help="$t('date_format_help')"
        @input="$emit('input', component)"
      />
      <LmSelect
        class="col-12 col-md-6"
        v-model="component.componentProps.timeFormat"
        :options="timeFormatOptions"
        :label="$t('time_format')"
        :help="$t('time_format_help')"
        @input="$emit('input', component)"
      />
      <LmSelect
        class="col-12 col-md-12"
        v-model="component.componentProps.align"
        :options="alignOptions"
        :label="$t('align')"
        :help="$t('align_help')"
        @input="$emit('input', component)"
      />
    </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmSelect from '@/components/form/elements/LmSelect'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmButton from '@/components/form/elements/LmButton'
import LmColorPicker from '@/components/form/elements/LmColorPicker'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

export default {
  data () {
    return {
      component: {},
      alignOptions: {
        content: [
          { value: 'left', text: this.$t('left') },
          { value: 'center', text: this.$t('centered') },
          { value: 'right', text: this.$t('right') }
        ]
      },
      dateFormatOptions: {
        content: [
          { value: 'DD-MM-YYYY', text: moment().format('DD-MM-YYYY') },
          { value: 'DD/MM/YYYY', text: moment().format('DD/MM/YYYY') },
          { value: 'dddd, Do MMMM YYYY', text: moment().format('dddd, Do MMMM YYYY') },
          { value: 'do MMMM YYYY', text: moment().format('do MMMM YYYY') }
        ]
      },
      timeFormatOptions: {
        content: [
          { value: 'HH:MM:ss', text: moment().format('HH:MM:ss') },
          { value: 'HH:MM', text: moment().format('HH:MM') },
          { value: 'h:mm a', text: moment().format('h:mm a') },
          { value: 'h:mm:ss a', text: moment().format('h:mm:ss a') }
        ]
      },
      deleteTypeOptions: {
        content: [{
          value: 'put',
          text: this.$t('logic')
        }, {
          value: 'delete',
          text: this.$t('permanent')
        }]
      }
    }
  },
  components: {
    LmTextInput,
    LmSelect,
    LmCheckbox,
    LmButton,
    LmColorPicker,
    LmNumberInput
  },
  props: {
    id: {
      type: Number
    },
    componentData: {
      type: Object,
      default: () => (
        {
          class: '',
          componentName: 'LmButton',
          componentProps: {
            isVisible: true,
            align: 'center'
          }
        }
      )
    },
    screens: {
      type: Array
    },
    availableProcesses: {
      type: Array
    }
  },
  computed: {
    filteredScreens () {
      return this.screens?.map(s => {
        return {
          value: s.id,
          text: s.title
        }
      }).filter(s => s?.value !== this.component.componentProps.currentScreenId)
    }
  },
  methods: {
  },
  created () {
    this.component = this.componentData
  }
}
</script>
